export default __webpack_public_path__ + "static/media/tdm.4b35b81d.png";